// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z7q3","question":"styles_question__vlk0l","inputVisibleButton":"styles_inputVisibleButton__15z-4","note":"styles_note__3sk02"};